import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

import { boardsActions } from '../../../store/boards';
import { Panel, PanelHeader, PanelBody } from '../../../components/admin/panel/panel';
import { pageTitle } from '../../../helpers/page-admin';

class Details extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...this.props.history.location.state                // Link to Parmeter로 넘어옴
        }
        for (var key in this.state) {
            if (this.state[key] === 'null') this.state[key] = null;
        }
    }

    onClickUpdate = (event) => {
        event.preventDefault();
        this.props.history.push({
            pathname: `/admin/boards/update/${this.state.boardId}`,
            state: {
                ...this.state
            }
        });
    }

    render() {
        return (
            <div>
                <h1 className="page-header">{pageTitle(this.state.category, this.state.subCategory).title}</h1>
                <Panel>
                    <PanelHeader>상세보기</PanelHeader>
                    <PanelBody>
                        <h4>{this.state.title}</h4>
                        <p>{moment(this.state.time).format("YYYY-MM-DD hh:mm")}</p>
                        
                        {this.state.files.map(function (item) {
                            if (item.type === 'thumbnails') {
                                return (<span key={item.fileId} className="m-b-0 m-r-15">섬네일 : <Link to={`/api/files/thumbnails/${item.name}`} target="_blank">{item.fileName}</Link></span>)
                            }
                            else if (item.type === 'attachments') {
                                return (<span key={item.fileId} className="m-b-0 m-r-15">첨부파일 : <Link to={`/api/files/attachments/${item.name}`} target="_blank">{item.fileName}</Link></span>)
                            }
                            return null;
                        })}
                      
                        {this.state.summary && <b>{this.state.summary}</b> }
                        <hr />
                        {this.state.content && <div dangerouslySetInnerHTML={{ __html: this.state.content }} />}

                        <hr />
                        <div className="form-group text-right p-t-15">
                            <button onClick={event => this.onClickUpdate(event)} className="btn btn-inverse rounded-0 m-r-5">수정</button>
                            <Link to={`/admin/boards/${this.state.category}/${this.state.subCategory}`} className="btn btn-success rounded-0 m-r-5">목록</Link>
                        </div>

                    </PanelBody>
                </Panel>
            </div>
        )
    }
}

export default connect(
    state => state.boards,
    dispatch => bindActionCreators({ ...boardsActions }, dispatch)
)(withRouter(Details));




// WEBPACK FOOTER //
// ./src/pages/admin/boards/details.js